import { render, staticRenderFns } from "./loginBox.vue?vue&type=template&id=3c36e0ca&scoped=true&"
import script from "./loginBox.vue?vue&type=script&lang=js&"
export * from "./loginBox.vue?vue&type=script&lang=js&"
import style0 from "./loginBox.vue?vue&type=style&index=0&id=3c36e0ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c36e0ca",
  null
  
)

export default component.exports